import { AppDomain } from '@ibk/shared-types';
export const SUPER_APP_DEEPLINK_URL_BY_DOMAIN = {
    [AppDomain.ESCRITORIO]: 'https://contabil.dominiosistemas.com.br/deeplink?module=home',
    [AppDomain.EMPRESA]: 'https://empresas.dominiosistemas.com.br/deeplink?module=home',
};
export const SUPER_APP_STORE_URLS_BY_DOMAIN = {
    [AppDomain.ESCRITORIO]: {
        android: 'https://play.google.com/store/apps/details?id=com.thomsonreuters.domino.accountant',
        ios: 'https://apps.apple.com/br/app/dom%C3%ADnio-escrit%C3%B3rio/id6468593700',
    },
    [AppDomain.EMPRESA]: {
        android: 'https://play.google.com/store/apps/details?id=com.thomsonreuters.domino.client',
        ios: 'https://apps.apple.com/br/app/dominio-empresa/id6468593687',
    },
};
